/**
 * External dependencies
 */
import React from "react";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./styles.scss";

const Header = (props) => {
  return <Box>Header</Box>;
};

export default Header;
